import angular from 'angular';
import { standardCharsValidator } from './standard-chars.validator';

export const StandardCharsValidator = angular
  .module('app.validators.standardChars', [])
  .directive('uStandardChars', standardCharsValidator);
